import {connect} from 'react-redux';

import {panel} from '../../base-image/actionCreators';

const BaseToggle = ({icon, title, className, onClick}) => (
    <div className={className} onClick={onClick}>
        <i className={`icon icon-${icon}`} title={title} />
    </div>
);

const mapDispatchToProps = (dispatch, {panelType, panelOpen}) => ({
    onClick: () => dispatch(panel(panelOpen === panelType ? false : panelType)),
});

export default connect(undefined, mapDispatchToProps)(BaseToggle);
